// @flow

/**
 * @module Constants/Auth
 * @desc Auth Constants
 */

import keyMirror from 'utils/keyMirror';

/**
 * @constant {Object} AuthConstants
 * @memberof Auth
 */
export const AuthConstants = keyMirror({
  AUTH_SIGN_IN: undefined,
  AUTH_SIGN_OUT: undefined,
});
